import { render, staticRenderFns } from "./LayerLegendImage.vue?vue&type=template&id=1f60df09&scoped=true"
import script from "./LayerLegendImage.vue?vue&type=script&lang=ts"
export * from "./LayerLegendImage.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./LayerLegendImage.vue?vue&type=style&index=0&id=1f60df09&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1f60df09",
  null
  ,true
)

export default component.exports